




































import mixins from 'vue-typed-mixins';
import SurveyUtils, { SurveyGroup } from '@/utils/SurveyUtils';
import { DataTableHeader, DataTableCompareFunction } from 'vuetify';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<SurveyGroup>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'name' },
        { text: this.$i18n.tc('model.common.state'), value: 'state' },
        { text: this.$i18n.tc('model.common.dueDate'), value: 'duedate' },
      ];
    },
  },
  data(): {
    surveyGroups?: SurveyGroup[];
    search: string;
    includeArchived: boolean;
  } {
    return {
      surveyGroups: undefined,
      search: '',
      includeArchived: false,
    };
  },
  async mounted() {
    try {
      this.surveyGroups = await SurveyUtils.api.surveyGroup.list({
        nonarchivedonly: !this.includeArchived,
      });
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      await this.$router.push({ name: 'survey-group-create' });
    },
    async edit(group: SurveyGroup) {
      await this.$router.push({
        name: 'survey-group-edit',
        params: { id: `${group.id}` },
      });
    },
    async remove(group: SurveyGroup) {
      await this.$confirm(
        this.$i18n.t('validation.confirmation.delete', [group.name]).toString(),
        async () => {
          if (group.id && this.surveyGroups) {
            this.$alert.hide('remove');
            await SurveyUtils.api.surveyGroup.remove(group.id);

            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [group.name],
              }),
            });

            const index = this.surveyGroups.findIndex(
              (val) => val.id === group.id
            );
            if (index >= 0) {
              this.surveyGroups.splice(index, 1);
            }
          }
        }
      );
    },
  },
  watch: {
    async includeArchived(newValue) {
      try {
        this.surveyGroups = undefined;
        this.surveyGroups = await SurveyUtils.api.surveyGroup.list({
          nonarchivedonly: !newValue,
        });
      } catch (error) {
        this.$alert.show('mount', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
